exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".gvl-faq p{margin-bottom:0}.gvl-faq h3+p{margin-top:10px}.gvl-faq p+p,.gvl-faq ul+p,.gvl-faq li+li{margin-top:8px}.gvl-faq p+h3{margin-top:16px}", ""]);

